import { cn } from "@/lib/utils";

const TitleH5 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h5
      className={cn(
        "text-primary leading-[1.35] font-light tracking-wide text-[calc(16px*var(--heading-scale,1))] lg:text-[calc(17px*var(--heading-scale,1))] lg:leading-[1.5294]",
        className,
      )}
    >
      {title}
    </h5>
  );
};

export default TitleH5;
